import React from "react";
import { TextField } from "@material-ui/core";

const InputDate = (props) => {
  return (
    <TextField
      type="date"
      defaultValue={props.value}
      InputLabelProps={{
        shrink: true,
      }}
      onChange={(e) => props.Change_Data(props.data_key, e.target.value)}
    />
  );
};

export default InputDate;
